import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", {
      class: _normalizeClass(["text-body mb-0_5", _ctx.featured ? 'text-type-5-bold ' : 'text-type-7-bold '])
    }, _toDisplayString(_ctx.label), 3),
    _createElementVNode("p", {
      class: _normalizeClass(_ctx.featured ? 'display-title' : 'text-type-2-bold')
    }, _toDisplayString(_ctx.value), 3)
  ], 64))
}